import React from 'react'

function QrSlide() {
  return (
    <div>qrSlide</div>
  )
}

export default QrSlide